const USER_CANCELED_PATTERN = /user\s+(cancel{1,2}ed|rejected)/i;

export const isMagicUserCanceled = (error: unknown): boolean => {
  if (error == null || typeof error !== 'object') return false;
  const { message } = error as { message?: string };
  return USER_CANCELED_PATTERN.test(message ?? '');
};
